import { SealLogo } from "../components/StampHeader";

// Shown for the bare scan.story-stamp.com root with no /q/:code. People
// occasionally land here by typing the domain directly — give them a soft
// landing instead of a 404.

export default function Landing() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-6 gap-5">
      <SealLogo className="w-20 h-20" />
      <h1 className="text-3xl font-semibold tracking-tight text-textPrimary">
        Story Stamp
      </h1>
      <p className="text-textSecondary max-w-sm">
        Scan a Story Stamp sticker with your phone camera to read the story
        behind the object it's attached to.
      </p>
      <a
        href="https://storystamp.com"
        className="mt-2 px-6 py-3 rounded-full bg-primary text-white font-medium"
      >
        Visit storystamp.com
      </a>
    </div>
  );
}
